import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/basic/bscFileInfo',
    page(query){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    selectById(query){
        return http({
            url: this.baseurl+'/selectById',
            method: 'post',
            params: query
        });
    },
    selectByIdyszc(query){
        return http({
            url: this.baseurl+'/selectByIdyszc',
            method: 'post',
            params: query
        });
    }
}
